/* eslint-disable no-unused-vars */
export enum TextMarginBottom {
  LARGE = 'large',
  MEDIUM = 'medium',
  SMALL = 'small',
  TINY = 'tiny',
  NONE = 'none',
}
